module.exports = __webpack_public_path__ + "static/media/snoopybrokenclouds01.fc92741b.gif";